import { required } from 'vue-mc/validation'

import MongoModel from './MongoModel'

export default class Comment extends MongoModel {
  modelName = 'Comment'
  collection = 'comments'
  autoFields = true

  defaults () {
    return {
      id: null,
      organization: null,
      entityRef: null,
      content: '',
      project: null
    }
  }

  mutations () {
    return {
    }
  }

  validation () {
    return {
      entityRef: required,
      content: required,
      project: required
    }
  }
}
